/**
 * 사용법.
 * export default withStore({
 *   stateMap: { myAccount: ["username","tokenObj"] },
 *   dispatchMap: ["myAccount"]
 * })(TargetComponent);
 */

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

const _capitalize = inputString => {
  return inputString.charAt(0).toUpperCase() + inputString.slice(1);
};

const _returnStateFn = inputObj => state => {
  const returnObj = {};

  if (!inputObj) return returnObj;

  for (const moduleName in inputObj) {
    if (inputObj.hasOwnProperty(moduleName)) {
      const varNameArr = inputObj[moduleName];
      for (let i = 0; i < varNameArr.length; i++) {
        const varName = varNameArr[i];

        returnObj[varName] = state[moduleName].toJS()[varName];
      }
    }
  }

  return returnObj;
};

const _returnDispatchFn = inputArr => dispatch => {
  const returnObj = {};

  if (!inputArr) return returnObj;

  for (let i = 0; i < inputArr.length; i++) {
    const moduleName = inputArr[i];

    const currentModule = require(`store/modules/${moduleName}`);

    returnObj[`${_capitalize(moduleName)}Actions`] = bindActionCreators(
      currentModule,
      dispatch
    );
  }

  return returnObj;
};

const withStore =
  ({ stateMap, dispatchMap }) =>
  WrappedComponent => {
    return connect(
      _returnStateFn(stateMap),
      _returnDispatchFn(dispatchMap)
    )(WrappedComponent);
  };

export { withStore };
